// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Xqu_q","inputWrap":"Table_inputWrap__305Tz","col":"Table_col__2bLTm","bmiTooltip":"Table_bmiTooltip__3NEed"};